import {useAuth0} from "@auth0/auth0-react";
import {Box} from "@mui/material";

import LoginButton from "./LoginBtn";
import Profile from "./ProfileBtn";

function LoginLayout() {
  const {isLoading} = useAuth0();
  if (isLoading) return <div>Loading...</div>;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: {xs: 1, sm: 1.5, md: 2},
      }}
    >
      <Box
        sx={{
          flexGrow: 0,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Profile />
      </Box>
      <Box
        sx={{
          flexGrow: 0,
          display: "flex",
          alignItems: "center",
        }}
      >
        <LoginButton />
      </Box>
    </Box>
  );
}

export default LoginLayout;
